<template>
  <div class="form__group--border py-16 pb-32">
    <legend class="form__label pb-4">{{ legendText }}</legend>
    <poppins-text-field
      id="years-experience"
      ref="yearsExperienceTextField"
      v-model="yearsExperience"
      label-name="Years of experience"
      :aria-label="legendText"
      name="years-experience"
      type="text"
      pattern="\d{1,2}"
      inputmode="numeric"
      :status="formStatuses.yearsExperience"
      :required="true"
      :helper-text="helperText(formStatuses.yearsExperience)"
      @blur="validate"
    />
  </div>
</template>

<script lang="ts">
import lowerCase from 'lodash/lowerCase';
import { mapActions, mapGetters, mapState } from 'vuex';
import helperStatus from '@/helpers/status';
import TextField from '@/components/textfield/TextField.vue';
import focusOnElement, { FocusOnElementOptions } from '@/helpers/focusHelper';

export default {
  name: 'YearsExperienceField',
  components: {
    PoppinsTextField: TextField,
  },
  data(): any {
    return {
      formStatuses: {
        yearsExperience: helperStatus.Neutral,
      },
    };
  },
  computed: {
    ...mapState(['careType']),
    ...mapGetters(['getFormField']),
    yearsExperience: {
      get() {
        return this.getFormField('yearsExperience');
      },
      set(newValue) {
        this.formStatuses.yearsExperience = helperStatus.Neutral;
        return this.updateForm({ key: 'yearsExperience', value: newValue });
      },
    },
    legendText(): string {
      const lowerCaseCareType = lowerCase(this.careType);
      return `Years of paid ${lowerCaseCareType} experience`;
    },
    fieldIsValid(): boolean {
      return this.yearsExperience && this.yearsExperience <= 50 && this.yearsExperience >= 0;
    },
  },
  methods: {
    ...mapActions(['updateForm']),
    validate() {
      if (!this.fieldIsValid) {
        this.formStatuses.yearsExperience = helperStatus.Error;
      }
      return this.formStatuses.yearsExperience;
    },
    helperText(status: helperStatus) {
      if (status === helperStatus.Neutral) return '';

      if (this.yearsExperience > 50) {
        return 'Years of experience should be between 0 and 50';
      }
      return 'Enter years of paid experience';
    },
    focusElement(options: FocusOnElementOptions = {}) {
      focusOnElement(this.$refs.yearsExperienceTextField.$el.querySelector('input'), options);
    },
  },
};
</script>
